import controller from './home.controller'
import template from './home.html';
import './home.scss';

let module = angular.module('home', [
	'ionic'
])
.config(($stateProvider, $urlRouterProvider) => {
	"ngInject";

	$urlRouterProvider.otherwise('/tab/home');

	$stateProvider
		.state('tab.home', {
			url: '/home',
			views: {
				'tab-home': {
					template: template,
					controller: controller,
					controllerAs: 'home',
				}
			}
		})
})
.name;

export default module;



// WEBPACK FOOTER //
// ./app/components/home/home.js